<div id="google_translate_element" *ngIf="hasGoogleTranslate"></div>
<router-outlet></router-outlet>
